import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import { useDebouncedValue } from '@shared/hooks/useDebouncedValue';
import type { Port } from '@shared/types';

export function usePortSearch(search: string) {
  const debouncedSearch = useDebouncedValue(search, 300);

  const { data: allPorts } = useQuery({
    queryKey: queryKeys.allPorts,
    queryFn: () => apiClient.get<Port[]>('/ports'),
    staleTime: Infinity,
  });

  const data = useMemo(() => {
    if (debouncedSearch.length < 2 || !allPorts) return [];

    const term = debouncedSearch.toLowerCase();
    return allPorts.filter(
      (p) =>
        p.name?.toLowerCase().includes(term) ||
        p.locode?.toLowerCase().includes(term) ||
        p.wpi?.includes(term),
    );
  }, [debouncedSearch, allPorts]);

  return {
    data,
    isLoading: false,
    isError: false,
  };
}
